module.exports = __webpack_public_path__ + "static/media/fishy.e5311607.png";